export default {
  section: {
    width: "98%",
    margin: "0 auto 0.5rem auto",
    border: "2px solid black",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    background: "white"
  },
  sectionColours: [
    "#ff5555",
    "#ff7755",
    "#fff055",
    "#99cc33",
    "#5699ff",
    "#cc99ff"
  ],
  title: {
    display: "block",
    width: "100%",
    height: "1.5rem",
    padding: "1rem",
    border: "none",
    textAlign: "center",
    fontSize: "1.2rem",
    fontWeight: "400",
    background: "grey"
  },
  text: {
    display: "block",
    width: "90%",
    height: "2rem",
    padding: "0.2rem",
    border: "none",
    margin: "0.5rem",
    fontSize: "1rem",
    resize: "vertical",
    opacity: "0.9"
  },
  addButton: {
    marginLeft: "1.5rem",
    marginBottom: "-1rem",
    marginRight: "98%",
    width: "1.5rem",
    border: "none",
    padding: "0.5rem",
    backgroundColor: "transparent"
  },
  deleteButton: {
    marginRight: "1.5rem",
    marginTop: "-1rem",
    marginLeft: "98%",
    width: "1.5rem",
    border: "none",
    padding: "0.5rem",
    backgroundColor: "transparent",
    color: "#e22"
  }
};
